/**
 * IntegrationListingGrid
 *
 * Grid component for the IntegrationListing page.
 * Delegates configuration and data-fetching to `useIntegrationGridConfig`,
 * keeping this component purely presentational.
 *
 * Error state: shown as an inline alert so the user can see the problem
 * without losing the filter/header chrome.
 */

import DataGrid from 'components/DataGrid';
import LoadingScreen from 'components/LoadingScreen';
import React, { Suspense } from 'react';

import { useIntegrationGridConfig } from './IntegrationListingGrid.config';

const IntegrationListingGrid: React.FC = () => {
  const { config, data, loading } = useIntegrationGridConfig();

  return (
    <Suspense fallback={<LoadingScreen />}>
      <DataGrid config={config} data={data} loading={loading} />
    </Suspense>
  );
};

export default IntegrationListingGrid;
